import { get } from 'utils/request';

export async function fetchActivityRule() {
  try {
    const result = await get('https://query.aliyun.com/rest/groupBuying.rule', {}, { contentType: 'html' });
    return result.data;
  } catch (error) {
    console.error(error);
  }
}

export async function fetchLeagueRule() {
  try {
    const result = await get('https://query.aliyun.com/rest/groupBuying.pkRule', {}, { contentType: 'html' });
    return result.data;
  } catch (error) {
    console.error(error);
  }
}

// 获取团pk信息
export async function fetchLeagueTable() {
  try {
    const result = await get('https://query.aliyun.com/rest/groupBuying.pk', {});
    return result.data;
  } catch (error) {
    console.error(error);
  }
}

export async function fetchPCActivityRule() {
  try {
    const result = await get('https://query.aliyun.com/rest/groupBuying.pcRule', {}, { contentType: 'html' });
    return result.data;
  } catch (error) {
    console.error(error);
  }
}

export async function fetchPCActivityRule12() {
  try {
    const result = await get('https://query.aliyun.com/rest/groupBuying.12pcRule', {}, { contentType: 'html' });
    return result.data;
  } catch (error) {
    console.error(error);
  }
}

export async function fetchH5DiscountRule() {
  try {
    const result = await get('https://query.aliyun.com/rest/groupBuying.discountRule', {}, { contentType: 'html' });
    return result.data;
  } catch (err) {
    console.error(err);
  }
}

export async function fetchDashiRule() {
  try {
    const result = await get('https://query.aliyun.com/rest/groupBuying.aliyunDashi', {}, { contentType: 'html' });
    return result.data;
  } catch (err) {
    console.error(err);
  }
}

export async function fetchRuleWithoutPacket() {
  try {
    const result = await get(
      'https://query.aliyun.com/rest/groupBuying.ruleWithoutPacket',
      {},
      { contentType: 'html' }
    );
    return result.data;
  } catch (err) {
    console.error(err);
  }
}

export async function fetchGroupRule() {
  try {
    const result = await get('https://query.aliyun.com/rest/groupBuying.groupRules', {}, { contentType: 'html' });
    return result.data;
  } catch (err) {
    console.error(err);
  }
}



// WEBPACK FOOTER //
// ./src/scripts/services/HomeService.js